<template>
    <div class="fcsdNotice">
        <div class="left">

            <div class="tit"> {{
					lotteryType == 2?'福彩3D':
					lotteryType == 3?'排列三':''
				}}开奖结果</div>
            <div class="table">
                <div>
                    <span>期号</span>
                    <span>开奖日期</span>
                    <span>销售金额</span>
                    <span>
                        {{
							lotteryType == 2?'福彩3D':
							lotteryType == 3?'排列三':''
						}}开奖结果
                    </span>
                </div>
                <div v-for="(item, index) in list"
                     :key="index">
                    <span>{{item.cycle}}</span>
                    <span>{{item.openTimestamp && item.openTimestamp | handleTime}}</span>
                    <span>{{item.saleMoney}}元</span>

                    <span v-if="lotteryType == 2"><a href="https://caipiao.ip138.com/3d/"
                           target="_blank"
                           class="res">{{item.openNbr}}</a></span>

					<span v-if="lotteryType == 3"><a href="https://caipiao.ip138.com/pailie3/"
                           target="_blank"
                           class="res">{{item.openNbr}}</a></span>

						   
                </div>
            </div>
        </div>

        <!-- <div class="right">
			<template v-if="lotteryType == 2">
				<div>福彩<span>3D</span>词典</div>
            	<div>福彩<span>3D</span>技巧</div>
			</template>
			<template v-if="lotteryType == 3">
				<div>排列三词典</div>
				<div>排列三技巧</div>
			</template>
        </div> -->

    </div>
</template>

<script>
export default {
    props: ['lotteryType'],
    filters: {
        handleTime (timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    },
    data () {
        return {
            db: {},
            list: [],
        }
    },
    mounted () {
        this.getdb()
    },
    methods: {
        getdb () {
            let lotteryType = this.lotteryType //福彩3d:2,pls:3

            this.$http.get('/stage-api/pre/record/forecast/runBaseLottery?type=' + lotteryType + '&limit=7').then(res => {
                // this.$http.get('/stage-api/pre/record/forecast/runBaseLottery?type='+lotteryType+'&limit=7').then(res=>{
                // console.log('-----', lotteryType, JSON.parse(JSON.stringify(res.data)));
                this.list = res.data.splice(0, 9)
            })

        }
    }
};
</script>

<style lang="scss" scoped>
.fcsdNotice {
    display: flex;
    .left {
        flex: 1;
        font-size: 15px;
        .tit {
            font-weight: bold;
            color: #066baf;
            font-size: 28px;
        }
        .table {
            text-align: center;
            border: 1px solid rgba(0, 0, 0, 0.05);
            > div {
                display: grid;
                grid-template-columns: 1.8fr 2fr 2fr 2.5fr;
                &:nth-child(odd) {
                    color: #066baf;
                    background-color: #e4f4ff;
                }
                span {
                    padding: 6px 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    border-right: 1px solid rgba(0, 0, 0, 0.05);
                }
                &:first-child {
                    span {
                        padding: 10px 0;
                        white-space: nowrap;
                    }
                }
                .res {
                    color: red;
                }
            }
        }
    }
    .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > div {
            width: 100px;
            height: 180px;
            font-size: 20px;
            color: #c33124;
            text-align: center;
            line-height: 100px;
            writing-mode: vertical-lr;
            letter-spacing: 10px;
            span {
                line-height: 30px;
                letter-spacing: 0px;
                writing-mode: horizontal-tb;
            }
        }
    }
}
</style>